// extracted by mini-css-extract-plugin
export default {"pageHeight":"ShipmentPage__pageHeight__Ri1oe"};
    if(module.hot) {
      // 1763020726950
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  